export default __webpack_public_path__ + "static/media/main_graphic.e48ecd30.svg";